import { apiFetch } from '@/lib/api'
import type { PreferencesService } from '@/services/contracts'
import type { components } from '@/types/api'
import type { TablePreferences } from '@/types/models'

const path = (tableId: string) => `/users/me/table-preferences/${encodeURIComponent(tableId)}`

export const httpPreferencesService: PreferencesService = {
  async getTable(tableId) {
    const raw = await apiFetch<components['schemas']['TablePreferences']>(path(tableId))
    return {
      column_order: raw.column_order ?? [],
      column_sizing: raw.column_sizing ?? {},
      column_visibility: raw.column_visibility ?? {},
    }
  },
  async saveTable(tableId, preferences: TablePreferences) {
    await apiFetch(path(tableId), { method: 'PUT', body: preferences })
  },
  async resetTable(tableId) {
    await apiFetch(path(tableId), { method: 'DELETE' })
  },
}
